const WithTemplateWrapper = (Component) => {
  const templateOptions = {};

  const NewComponent = (props) => {
    return (
      <>
        <Component {...props} templateWrapperOptions={templateOptions} />
      </>
    );
  };
  return NewComponent;
};

export default WithTemplateWrapper;
